import React, { Suspense, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import { Grid } from "@mui/material";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Pagina = React.lazy(() => import('./Pagina/Pagina'));

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-in-out',
        });
    }, []);

    return (
        <HelmetProvider>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Suspense fallback={<div />}>
                    <Pagina />
                </Suspense>
            </Grid>
        </HelmetProvider>
    );
}

export default App;